<div class="panel text-11 text-uppercase">
  <div class="panel__count">
    {{ count | number }} <span *ngIf="count === 1">structure</span><span *ngIf="count > 1">structures</span> selected
  </div>

  <div class="panel__clear">
    <button buttonSize="small" app-button (click)="handleClearClick()">Clear</button>
  </div>
</div>